import Vue from 'vue';
import App from './app.vue';
import router from './router';
import store from './store';
import Loading from '@/commons/loading';
import './commons';
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import ElementUI from 'element-ui';
import VueLazyLoad from 'vue-lazyload';
import { getParamString } from '@/commons/utils';
import './assets/quill.snow.css';

Vue.use(VueLazyLoad, {
    preLoad: 1,
    loading: 'http://devdevnew.oss.aikucun.com/7fae0aa769ebf3096b8e6e8f64650b8b05375934_1563775156086_93.png',
    error: '',
    attempt: 1
});
Vue.use(ElementUI);
Vue.use(Loading);
Vue.use(VueVideoPlayer);
Vue.component('vue-draggable-resizable', VueDraggableResizable);

Vue.config.productionTip = false;

let code = getParamString('code');
if (code) {
    store.commit('navCode', { navCode: code });
}

/* eslint-disable */
var _hmt = _hmt || [];
window._hmt = _hmt;
(function () {
    var hm = document.createElement('script');
    hm.src = 'https://hm.baidu.com/hm.js?b013c60f42887b32ff440f1d55bf70d9';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(hm, s);
})();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
